import { Type } from '@dipscope/type-manager';
import { Node } from './Node';
import logger from '../../logger';

@Type({ injectable: true })
export class Entity extends Set<Node> {}

@Type({ injectable: true })
export class EntityFeatures {
  singleNodeType: boolean;
  completable: boolean;
  completedScore: number;
  uncompletedScore: number;

  constructor(obj: unknown) {
    if (!obj) return;
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }
}

@Type({ injectable: true })
export class EntityMap extends Map<string, EntityFeatures> {
  constructor(init) {
    super(init);
    logger.info('new EntityMap');
  }
}
